import { createApp } from 'vue'
import App from './App.vue'
import './global.vue';

createApp(App).mount('#app')
